import React, { useEffect, useState, createElement } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Leaf, PlayCircle, Printer, MonitorPlay, Sparkles, Star, Clock, Gift, Home, Palette, BookOpen, Download, ChevronLeft, ChevronRight } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { AutoCarousel } from '../components/AutoCarousel';
import { AccordionItem } from '../components/Accordion';
const GLASS_IMAGES = {
  frascos: ['https://cdn.magicpatterns.com/uploads/q9CKTtznGMUvP7TeipTNzf/FRASCOS_DECORATIVOS_1.jpg', 'https://cdn.magicpatterns.com/uploads/i6j3z1b59ziqvKLhxei3PB/FRASCOS_DECORATIVOS_2.jpg', 'https://cdn.magicpatterns.com/uploads/urCu6JwhrVBCQ5jUm4ujDP/FRASCOS_DECORATIVOS_3.jpg'],
  portavelas: ['https://cdn.magicpatterns.com/uploads/6kUaK2m2EyKK7XDWjLdwfy/PORTAVELAS_1.jpg', 'https://cdn.magicpatterns.com/uploads/c2tgitFdom586VmnLaKJRi/PORTAVELAS_2.jpg'],
  botellas: ['https://cdn.magicpatterns.com/uploads/7QRV8NuY8VDSjnTtyw66wP/BOTELLAS_DECORADAS.jpg', 'https://cdn.magicpatterns.com/uploads/9xct1iRgePGjnmoEH2NaBY/BOTELLAS_DECORADAS_2.jpg'],
  atrapasoles: ['https://cdn.magicpatterns.com/uploads/pHJQj2pwNV8xswzuPecqNx/ATRAPASOL_1.jpg', 'https://cdn.magicpatterns.com/uploads/v6MGp1z4PX2T9QeGDzj4Cc/ATRAPASOL_2.jpg', 'https://cdn.magicpatterns.com/uploads/4XZncMxPVuLcMfvn846zP7/ATRAPASOL_3.jpg'],
  bandejas: ['https://cdn.magicpatterns.com/uploads/qGVnvzfkDNzgUatiwHrGda/BANDEJAS_VIDRIO_1.jpg', 'https://cdn.magicpatterns.com/uploads/iyqtJSizy9RecLJNPgaa4W/BANDEJAS_VIDRIO_2.jpg', 'https://cdn.magicpatterns.com/uploads/tdxrbg6h5fr2aksW4Mm5Vo/BANDEJAS_VIDRIO_3.jpg'],
  souvenirs: ['https://cdn.magicpatterns.com/uploads/mqijXpJRrYS7t1SzTXrvQ1/SOUVENIRS_1.jpg', 'https://cdn.magicpatterns.com/uploads/pN4zdymZAB7oHCcAAMJShU/SOUVENIRS_2.jpg']
};
const MOSAIC_IMAGES = {
  macetas: ['https://cdn.magicpatterns.com/uploads/u83zp2Fhr8unPRNYfmkAC2/MACETA_MOSAIQUISMO.jpg', 'https://cdn.magicpatterns.com/uploads/1DS2nJJ5ZicZCsTaiM6HJT/MACETAS_MOSAIQUISMO.jpg', 'https://cdn.magicpatterns.com/uploads/uusQLRj68oxXzkgjXxsnBh/MACETAS_MOSAIQUISMO_2.jpg'],
  espejos: ['https://cdn.magicpatterns.com/uploads/1CKujkPaTKF7fy4hZzdm3G/ESPEJO_MOSAIQUISMO.jpg', 'https://cdn.magicpatterns.com/uploads/7JUZ7sSduQ4BMxrkfVceVM/ESPEJOS_MOSAIQUISMO.jpg'],
  bandejas: ['https://cdn.magicpatterns.com/uploads/6kUyDKhMghG7FwaJXYHjFC/BANDEJA_MOSAIQUISMO.jpg', 'https://cdn.magicpatterns.com/uploads/8sQJLAkcGJUTVP6XSV7S42/BANDEJA_MOSAIQUISMO_2.jpg'],
  posavasos: ['https://cdn.magicpatterns.com/uploads/3xEABeZADURNwe3uhs54bV/POSAVASOS_MOSAICO.jpg', 'https://cdn.magicpatterns.com/uploads/k2wKteRzBNLLYzcCiCAyM1/POSAVASOS_MOSAICO_2.jpg', 'https://cdn.magicpatterns.com/uploads/sQLgBPeaqunyh3Z3tRxzLs/POSAVASOS_MOSAICO_3.jpg'],
  numeros: ['https://cdn.magicpatterns.com/uploads/pYmxXjB8omrr2FWVHNM3kf/CARTEL_MOSAICO.jpg', 'https://cdn.magicpatterns.com/uploads/cXjhuejzhj7XJtSmjdQfXz/CARTEL_MOSAICO_2.jpg'],
  cuadros: ['https://cdn.magicpatterns.com/uploads/ufgcakryVq8EFRsfas6NJb/DECO_JARDIN_MOSAICO.jpg', 'https://cdn.magicpatterns.com/uploads/7hQ5rawPZGZhZyTRkXh3dV/DECO_JARDIN_MOSAICO_2.jpg', 'https://cdn.magicpatterns.com/uploads/mcXUzDz2ZqAEESpZtfzTBW/DECO_JARDIN_MOSAICO_3.jpg']
};
const TESTIMONIALS = ['https://cdn.magicpatterns.com/uploads/gfshkcmuMSe7t9jz2BeWA8/ChatGPT_Image_6_jun_2026,_16_03_38.png', 'https://cdn.magicpatterns.com/uploads/o74JHaDugNg4twXQt15Csy/ChatGPT_Image_6_jun_2026,_15_51_51.png', 'https://cdn.magicpatterns.com/uploads/2CHC6ZmtG6bNZFLo3BG6R9/ChatGPT_Image_6_jun_2026,_15_44_03.png', 'https://cdn.magicpatterns.com/uploads/aLREkyGq9JP1rJ7Fu2nkiQ/ChatGPT_Image_6_jun_2026,_15_39_03.png', 'https://cdn.magicpatterns.com/uploads/58w3TuCUiPvKGe3wMTdfZq/ChatGPT_Image_6_jun_2026,_15_35_48.png'];
const FAQS = [{
  q: '¿Es un producto físico o digital?',
  a: 'Es un producto 100% digital. Recibís acceso al curso, guías, plantillas, checklists y bonus para ver, descargar e imprimir.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. Está pensado para principiantes que quieren empezar desde cero.'
}, {
  q: '¿Necesito un taller grande?',
  a: 'No. Podés comenzar desde casa con una mesa cómoda, buena luz y materiales básicos.'
}, {
  q: '¿Tengo que comprar muchos materiales?',
  a: 'No. El kit incluye checklists para saber qué comprar primero y qué puede esperar.'
}, {
  q: '¿Las plantillas se imprimen?',
  a: 'Sí. Las plantillas están pensadas para imprimir y usar como guía en tus proyectos.'
}, {
  q: '¿Incluye videos?',
  a: 'Sí. Incluye curso con videos tutoriales para aprender paso a paso.'
}, {
  q: '¿Puedo vender las piezas que haga?',
  a: 'Sí. Podés vender las piezas físicas que crees. Además, recibís una guía de emprendimiento y venta.'
}, {
  q: '¿Tengo acceso de por vida?',
  a: 'Sí. Pagás una sola vez y podés consultar el contenido cuando quieras.'
}, {
  q: '¿Qué diferencia tiene con una clase mensual?',
  a: 'No dependés de horarios, traslados ni pagos todos los meses. Accedés al material completo y avanzás a tu ritmo.'
}];
const CHECKOUT_URL = 'https://pago.atlasdigitalhub.com/cart/43003208859746:1';
export function Landing() {
  const {
    formatted: countdown
  } = useCountdown(1800); // 30 minutes
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  // Meta Pixel
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    const f = w;
    const b = document;
    const n = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = b.getElementsByTagName('script')[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      ;
      (b.head || b.body || b.documentElement).appendChild(t);
    }
    w.fbq('init', '989000920158429');
    w.fbq('track', 'PageView');
  }, []);
  const handleCheckout = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  };
  const prevTestimonial = () => setTestimonialIndex(i => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const nextTestimonial = () => setTestimonialIndex(i => (i + 1) % TESTIMONIALS.length);
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-crema text-marron-suave font-sans" data-id="element-12">
      {/* 1. Top Bar */}
      <div className="bg-terracota text-blanco-calido py-2 px-4 text-center text-xs md:text-sm font-medium sticky top-0 z-50 shadow-md" data-id="element-13">
        <p className="flex flex-col md:flex-row items-center justify-center gap-1 md:gap-3" data-id="element-14">
          <span data-id="element-15">
            Producto 100% digital · Acceso inmediato · Oferta por tiempo
            limitado
          </span>
          <span className="bg-blanco-calido/20 px-2 py-0.5 rounded-full font-bold tracking-wider" data-id="element-16">
            Termina en: {countdown}
          </span>
        </p>
      </div>

      {/* 2. Logo & Social Proof */}
      <header className="pt-6 pb-2 flex flex-col justify-center items-center bg-blanco-calido/50" data-id="element-17">
        <img src="https://cdn.magicpatterns.com/uploads/5ZigZuXxwGGLDXYnP8vuh8/LOGO_DECOEMPRENDE.png" alt="Deco Emprende" className="h-12 md:h-14 object-contain" data-id="element-18" />
      </header>

      <main data-id="element-19">
        {/* 3. Hero */}
        <section className="px-5 md:px-8 max-w-3xl mx-auto text-center pt-3 pb-8" data-id="element-20">
          {/* Social proof */}
          <motion.div initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} className="flex flex-col items-center gap-2 mb-5" data-id="element-21">
            <img src="https://cdn.magicpatterns.com/uploads/ssZzxhUNXsE9dnVHSphapT/imagen_calificacion.png" alt="Reseñas de clientas — 5 estrellas" className="w-44 md:w-52 h-auto object-contain" data-id="element-22" />
            <span className="text-xs md:text-sm text-taupe font-medium" data-id="element-23">
              <span className="font-bold text-marron-suave" data-id="element-24">+600 alumnas</span>{' '}
              ya forman parte de Deco Emprende
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.05
        }} className="font-serif sm:text-3xl md:text-[40px] lg:text-[44px] font-bold text-marron-suave tracking-tight leading-[1.1] max-w-2xl mx-auto mb-4 text-[30px]" data-id="element-25">
            Aprendé Arte en Vidrio y Mosaiquismo desde casa,
            <span className="block text-terracota" data-id="element-26">
              aunque empieces desde cero
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.12
        }} className="text-base md:text-lg text-taupe font-light max-w-md md:max-w-lg mx-auto mb-7 leading-relaxed" data-id="element-27">
            Creá piezas decorativas, regalos y productos para vender con videos,
            guías y plantillas listas para usar.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.18
        }} className="relative max-w-xl mx-auto mb-8 rounded-2xl overflow-hidden shadow-premium" data-id="element-28">
            <img src="https://cdn.magicpatterns.com/uploads/d1FGiWGgCbK8UASX1vvKHR/ChatGPT_Image_5_jun_2026,_20_22_40.png" alt="Kit Digital Deco Emprende" className="w-full h-auto object-cover" data-id="element-29" />
          </motion.div>

          <div className="flex flex-col md:flex-row flex-wrap justify-center gap-3 max-w-3xl mx-auto" data-id="element-30">
            {['2 técnicas en 1: Arte en Vidrio + Mosaiquismo', 'Curso con videos tutoriales paso a paso', 'Plantillas imprimibles listas para usar', 'Ideal para crear, regalar o vender desde casa'].map((bullet, i) => <div key={i} className="flex items-start md:items-center gap-2 bg-blanco-calido px-4 py-2.5 rounded-xl md:rounded-full shadow-sm border border-beige-claro text-left" data-id="element-31">
                <CheckCircle2 className="w-5 h-5 text-verde-salvia flex-shrink-0 mt-0.5 md:mt-0" data-id="element-32" />
                <span className="text-sm md:text-base font-medium text-marron-suave" data-id="element-33">
                  {bullet}
                </span>
              </div>)}
          </div>
        </section>

        {/* 4. Why this course */}
        <section className="py-12 bg-blanco-calido px-4 md:px-8" data-id="element-34">
          <div className="max-w-5xl mx-auto" data-id="element-35">
            <div className="text-center mb-10" data-id="element-36">
              <h2 className="font-serif md:text-4xl font-bold text-marron-suave mb-3 text-[28px]" data-id="element-37">
                ¿Por qué este curso es ideal?
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-38">
              {[{
              title: 'No pagás todos los meses',
              desc: 'Accedés una sola vez y tenés el material para siempre.',
              icon: Clock
            }, {
              title: 'A tu ritmo desde casa',
              desc: 'Sin horarios fijos, sin traslados y sin presión.',
              icon: Home
            }, {
              title: 'Kit digital completo',
              desc: 'Videos, plantillas, checklists y recursos.',
              icon: BookOpen
            }, {
              title: 'Sin gran inversión',
              desc: 'Te muestra qué comprar primero y qué puede esperar.',
              icon: Star
            }, {
              title: 'Sin taller grande',
              desc: 'Con una mesa cómoda y buena luz ya podés empezar.',
              icon: Palette
            }, {
              title: '2 técnicas en 1',
              desc: 'Vidrio + Mosaiquismo para más variedad de piezas.',
              icon: Sparkles
            }].map((item, i) => <div key={i} className="bg-crema p-5 rounded-2xl shadow-sm border border-beige-claro/50 flex flex-col" data-id="element-39">
                  <div className="w-10 h-10 bg-terracota/10 rounded-xl flex items-center justify-center mb-4" data-id="element-40">
                    <item.icon className="w-5 h-5 text-terracota" data-id="element-41" />
                  </div>
                  <h3 className="font-serif text-xl font-bold text-marron-suave mb-2" data-id="element-42">
                    {item.title}
                  </h3>
                  <p className="text-sm text-taupe leading-relaxed" data-id="element-43">
                    {item.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* 5. What you can create */}
        <section className="py-16 px-4 md:px-8 bg-crema relative overflow-hidden pt-[30px] pb-[30px]" data-id="element-44">
          <div className="max-w-5xl mx-auto relative z-10" data-id="element-45">
            <div className="text-center mb-12" data-id="element-46">
              <span className="font-script text-2xl text-terracota mb-1 block" data-id="element-47">
                Inspiración infinita
              </span>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-marron-suave mb-4" data-id="element-48">
                Mirá todo lo que podés crear con este Curso
              </h2>
              <p className="text-base md:text-lg text-taupe max-w-xl mx-auto" data-id="element-49">
                Piezas decorativas, regalos y souvenirs que podés hacer para tu
                casa o para vender.
              </p>
            </div>

            {/* Block A: Arte en Vidrio */}
            <div className="mb-16" data-id="element-50">
              <div className="mb-8 text-center md:text-left border-b border-taupe/20 pb-4" data-id="element-51">
                <h3 className="font-serif text-3xl font-bold text-terracota mb-2" data-id="element-52">
                  Arte en Vidrio
                </h3>
                <p className="text-base text-taupe" data-id="element-53">
                  Creá piezas con vidrio real, plantillas y diseños listos para
                  usar.
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-54">
                {[{
                name: 'Frascos',
                desc: 'Con vidrio de colores y florales.',
                imgs: GLASS_IMAGES.frascos
              }, {
                name: 'Portavelas',
                desc: 'Diseños geométricos y cálidos.',
                imgs: GLASS_IMAGES.portavelas
              }, {
                name: 'Botellas',
                desc: 'Intervenidas estilo boho.',
                imgs: GLASS_IMAGES.botellas
              }, {
                name: 'Atrapasoles',
                desc: 'Con flores, lunas y soles.',
                imgs: GLASS_IMAGES.atrapasoles
              }, {
                name: 'Bandejas',
                desc: 'Platos y piezas decorativas.',
                imgs: GLASS_IMAGES.bandejas
              }, {
                name: 'Souvenirs',
                desc: 'Mini frascos y regalos.',
                imgs: GLASS_IMAGES.souvenirs
              }].map((product, i) => <div key={i} className="bg-blanco-calido rounded-2xl overflow-hidden shadow-sm border border-beige-claro group" data-id="element-55">
                    <AutoCarousel images={product.imgs} className="h-32 md:h-40" data-id="element-56" />
                    <div className="p-3 md:p-4" data-id="element-57">
                      <h4 className="font-serif text-lg md:text-xl font-bold text-marron-suave mb-1 group-hover:text-terracota transition-colors" data-id="element-58">
                        {product.name}
                      </h4>
                      <p className="text-xs md:text-sm text-taupe line-clamp-2" data-id="element-59">
                        {product.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Block B: Mosaiquismo */}
            <div data-id="element-60">
              <div className="mb-8 text-center md:text-left border-b border-taupe/20 pb-4" data-id="element-61">
                <h3 className="font-serif text-3xl font-bold text-verde-oliva mb-2" data-id="element-62">
                  Mosaiquismo
                </h3>
                <p className="text-base text-taupe" data-id="element-63">
                  Creá piezas deco con teselas, venecitas, cerámica y pastina.
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-64">
                {[{
                name: 'Macetas',
                desc: 'Mosaico floral y colorido.',
                imgs: MOSAIC_IMAGES.macetas
              }, {
                name: 'Espejos',
                desc: 'Redondos y geométricos.',
                imgs: MOSAIC_IMAGES.espejos
              }, {
                name: 'Bandejas',
                desc: 'Florales y de cocina.',
                imgs: MOSAIC_IMAGES.bandejas
              }, {
                name: 'Posavasos',
                desc: 'Sets modernos para regalo.',
                imgs: MOSAIC_IMAGES.posavasos
              }, {
                name: 'Carteles',
                desc: 'Números y placas decorativas.',
                imgs: MOSAIC_IMAGES.numeros
              }, {
                name: 'Deco Jardín',
                desc: 'Cuadros y mandalas.',
                imgs: MOSAIC_IMAGES.cuadros
              }].map((product, i) => <div key={i} className="bg-blanco-calido rounded-2xl overflow-hidden shadow-sm border border-beige-claro group" data-id="element-65">
                    <AutoCarousel images={product.imgs} className="h-32 md:h-40" data-id="element-66" />
                    <div className="p-3 md:p-4" data-id="element-67">
                      <h4 className="font-serif text-lg md:text-xl font-bold text-marron-suave mb-1 group-hover:text-verde-oliva transition-colors" data-id="element-68">
                        {product.name}
                      </h4>
                      <p className="text-xs md:text-sm text-taupe line-clamp-2" data-id="element-69">
                        {product.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        {/* 6. How it works */}
        <section className="py-16 bg-beige-claro px-4 md:px-8" data-id="element-70">
          <div className="max-w-5xl mx-auto" data-id="element-71">
            <div className="text-center mb-12" data-id="element-72">
              <h2 className="font-serif md:text-4xl font-bold text-marron-suave text-[32px] mt-[-20px] mb-[-20px]" data-id="element-73">
                Así de simple es empezar
              </h2>
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-74">
              <div className="w-full md:w-1/2 space-y-6" data-id="element-75">
                {[{
                num: '1',
                title: 'Accedés al kit',
                desc: 'Recibís el curso y plantillas.',
                icon: Download
              }, {
                num: '2',
                title: 'Imprimís plantillas',
                desc: 'Usás los diseños en formato A4.',
                icon: Printer
              }, {
                num: '3',
                title: 'Seguís los videos',
                desc: 'Aprendés a tu ritmo paso a paso.',
                icon: MonitorPlay
              }, {
                num: '4',
                title: 'Creás tus piezas',
                desc: 'Decorás o vendés tus productos.',
                icon: Sparkles
              }].map((step, i) => <div key={i} className="flex gap-4 items-start" data-id="element-76">
                    <div className="w-10 h-10 rounded-full bg-blanco-calido shadow-sm flex items-center justify-center flex-shrink-0 border border-terracota/20 text-terracota font-serif text-xl font-bold" data-id="element-77">
                      {step.num}
                    </div>
                    <div data-id="element-78">
                      <h3 className="font-serif text-xl font-bold text-marron-suave mb-1" data-id="element-79">
                        {step.title}
                      </h3>
                      <p className="text-sm text-taupe" data-id="element-80">{step.desc}</p>
                    </div>
                  </div>)}
              </div>

              <div className="w-full md:w-1/2" data-id="element-81">
                <div className="rounded-2xl overflow-hidden shadow-md" data-id="element-82">
                  <img src="https://cdn.magicpatterns.com/uploads/anruN9scJAea1nFKaKD7y6/IMPRESION_PLANTILLAS.png" alt="Impresión de plantillas" className="w-full h-auto object-cover" data-id="element-83" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 7. What's included (Compact Redesign) */}
        <section className="py-16 px-4 md:px-8 bg-blanco-calido pt-[30px] pb-[30px] space-y-[4px]" data-id="element-84">
          <div className="max-w-4xl mx-auto" data-id="element-85">
            <div className="text-center mb-10" data-id="element-86">
              <span className="font-script text-2xl text-verde-oliva mb-1 block" data-id="element-87">
                El kit más completo
              </span>
              <h2 className="font-serif md:text-4xl font-bold text-marron-suave mb-4 text-[32px]" data-id="element-88">
                Todo lo que recibís hoy
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-89">
              <div className="bg-crema p-5 rounded-2xl border border-beige-claro" data-id="element-90">
                <h3 className="font-serif text-xl font-bold text-marron-suave mb-3 flex items-center gap-2" data-id="element-91">
                  <MonitorPlay className="w-5 h-5 text-terracota" data-id="element-92" /> Curso en
                  Videos
                </h3>
                <p className="text-sm text-taupe" data-id="element-93">
                  Videos paso a paso para aprender las técnicas a tu ritmo desde
                  casa.
                </p>
              </div>

              <div className="bg-crema p-5 rounded-2xl border border-beige-claro" data-id="element-94">
                <h3 className="font-serif text-xl font-bold text-marron-suave mb-3 flex items-center gap-2" data-id="element-95">
                  <Palette className="w-5 h-5 text-verde-salvia" data-id="element-96" /> Arte en
                  Vidrio
                </h3>
                <ul className="text-sm text-taupe space-y-1" data-id="element-97">
                  <li data-id="element-98">• Guía Inicial</li>
                  <li data-id="element-99">• +80 Plantillas Imprimibles</li>
                  <li data-id="element-100">• Checklist de Materiales</li>
                </ul>
              </div>

              <div className="bg-crema p-5 rounded-2xl border border-beige-claro" data-id="element-101">
                <h3 className="font-serif text-xl font-bold text-marron-suave mb-3 flex items-center gap-2" data-id="element-102">
                  <Sparkles className="w-5 h-5 text-verde-oliva" data-id="element-103" /> Mosaiquismo
                </h3>
                <ul className="text-sm text-taupe space-y-1" data-id="element-104">
                  <li data-id="element-105">• Guía Inicial</li>
                  <li data-id="element-106">• +80 Plantillas Imprimibles</li>
                  <li data-id="element-107">• Checklist de Materiales</li>
                </ul>
              </div>

              <div className="md:col-span-2 bg-terracota/5 p-6 rounded-2xl border-2 border-terracota/30 relative overflow-hidden" data-id="element-108">
                <h3 className="font-serif text-xl md:text-2xl font-bold text-terracota mt-2 mb-1 flex items-center gap-2" data-id="element-109">
                  <Gift className="w-6 h-6 text-terracota" data-id="element-110" /> Bonus incluidos
                  hoy
                </h3>
                <p className="text-xs text-taupe mb-4" data-id="element-111">
                  Sumás estos extras sin costo para inspirarte y empezar a
                  vender más rápido.
                </p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm text-marron-suave font-medium" data-id="element-112">
                  {['Guía de Emprendimiento y Venta', 'Paletas de Colores para crear', '+100 Ideas de Arte en Vidrio', '+100 Ideas de Mosaiquismo'].map((bonus, i) => <li key={i} className="flex items-start gap-2" data-id="element-113">
                      <Star className="w-4 h-4 text-terracota flex-shrink-0 mt-0.5 fill-terracota" data-id="element-114" />
                      <span data-id="element-115">{bonus}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* 9. Testimonials */}
        <section className="py-16 bg-crema px-4 md:px-8" data-id="element-116">
          <div className="max-w-5xl mx-auto" data-id="element-117">
            <div className="text-center mb-10" data-id="element-118">
              <h2 className="font-serif md:text-4xl font-bold text-marron-suave text-[36px] mt-[-20px] mb-[-20px]" data-id="element-119">
                Ellas ya empezaron
              </h2>
            </div>

            <div className="relative flex items-center justify-center gap-2 md:gap-4" data-id="element-120">
              <button type="button" onMouseDown={e => e.preventDefault()} onClick={prevTestimonial} aria-label="Testimonio anterior" className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-blanco-calido shadow-md border border-beige-claro flex items-center justify-center text-terracota hover:bg-terracota hover:text-blanco-calido transition-colors" data-id="element-121">
                <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" data-id="element-122" />
              </button>

              <div className="flex-1 max-w-md mx-auto" data-id="element-123">
                <div className="bg-blanco-calido rounded-2xl shadow-sm border border-beige-claro overflow-hidden flex items-center justify-center h-[70vh] max-h-[560px]" data-id="element-124">
                  <img src={TESTIMONIALS[testimonialIndex]} alt={`Testimonio ${testimonialIndex + 1}`} className="max-w-full max-h-full w-auto h-auto object-contain" data-id="element-125" />
                </div>
              </div>

              <button type="button" onMouseDown={e => e.preventDefault()} onClick={nextTestimonial} aria-label="Testimonio siguiente" className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-blanco-calido shadow-md border border-beige-claro flex items-center justify-center text-terracota hover:bg-terracota hover:text-blanco-calido transition-colors" data-id="element-126">
                <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-127" />
              </button>
            </div>

            <div className="flex justify-center gap-2 mt-6" data-id="element-128">
              {TESTIMONIALS.map((_, i) => <button key={i} type="button" onMouseDown={e => e.preventDefault()} onClick={() => setTestimonialIndex(i)} aria-label={`Ir al testimonio ${i + 1}`} className={`h-2.5 rounded-full transition-all ${i === testimonialIndex ? 'w-6 bg-terracota' : 'w-2.5 bg-taupe/30 hover:bg-taupe/50'}`} data-id="element-129" />)}
            </div>
          </div>
        </section>

        {/* 10. Benefits Summary */}

        {/* 11. Final Offer */}
        <section id="oferta" className="py-16 px-4 md:px-8 bg-terracota relative overflow-hidden" data-id="element-130">
          <div className="max-w-3xl mx-auto relative z-10 bg-blanco-calido rounded-3xl shadow-xl p-6 md:p-10 border-4 border-crema" data-id="element-131">
            <div className="text-center mb-8" data-id="element-132">
              <span className="inline-block bg-terracota text-blanco-calido px-4 py-1.5 rounded-full font-bold tracking-wider text-xs mb-4 animate-pulse" data-id="element-133">
                50% OFF SOLO POR HOY
              </span>
              <h2 className="font-serif md:text-4xl font-bold text-marron-suave mb-2 text-[32px]" data-id="element-134">
                Accedé hoy mismo
              </h2>
              <p className="md:text-xl font-serif text-terracota font-bold text-[24px]" data-id="element-135">
                Arte en Vidrio & Mosaico
              </p>
            </div>

            <div className="bg-beige-claro/50 rounded-2xl p-5 mb-8" data-id="element-136">
              <ul className="space-y-2 text-sm md:text-base" data-id="element-137">
                {['Curso con videos tutoriales', 'Guías Iniciales con paso a paso', '+160 Plantillas Imprimibles', 'Checklists de Materiales', 'BONOS EXTRAS INCLUIDOS'].map((item, i) => <li key={i} className="flex items-start gap-2 text-marron-suave" data-id="element-138">
                    <CheckCircle2 className="w-4 h-4 text-terracota flex-shrink-0 mt-0.5" data-id="element-139" />
                    <span className={item === 'BONOS EXTRAS INCLUIDOS' ? 'font-bold text-terracota' : ''} data-id="element-140">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center mb-6" data-id="element-141">
              <div className="flex flex-col items-center justify-center gap-1 mb-4" data-id="element-142">
                <span className="text-taupe text-sm line-through decoration-terracota/50 decoration-2" data-id="element-143">
                  Precio anterior: $39.990 ARS
                </span>
                <div className="flex items-end gap-1" data-id="element-144">
                  <span className="text-4xl md:text-5xl font-bold text-marron-suave" data-id="element-145">
                    $19.990
                  </span>
                  <span className="text-lg text-marron-suave font-bold mb-1" data-id="element-146">
                    ARS
                  </span>
                </div>
              </div>

              <button type="button" onClick={handleCheckout} className="w-full md:w-auto bg-terracota hover:bg-marron-suave text-blanco-calido text-lg md:text-xl font-bold py-4 px-10 rounded-full shadow-md transition-all transform hover:scale-105 mb-4" data-id="element-147">
                QUIERO COMENZAR
              </button>

              <p className="text-xs text-taupe font-medium flex flex-wrap justify-center gap-2" data-id="element-148">
                <span data-id="element-149">100% digital</span>
                <span data-id="element-150">·</span>
                <span data-id="element-151">Acceso inmediato</span>
                <span data-id="element-152">·</span>
                <span data-id="element-153">Pago único</span>
              </p>
            </div>

            <div className="bg-terracota/10 rounded-xl py-3 text-center" data-id="element-154">
              <p className="text-terracota text-sm font-bold flex items-center justify-center gap-2" data-id="element-155">
                <Clock className="w-4 h-4" data-id="element-156" />
                La oferta termina en: {countdown}
              </p>
            </div>
          </div>
        </section>

        {/* 12. FAQ */}
        <section className="py-16 bg-crema px-4 md:px-8" data-id="element-157">
          <div className="max-w-2xl mx-auto" data-id="element-158">
            <div className="text-center mb-10" data-id="element-159">
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-marron-suave mb-3" data-id="element-160">
                Preguntas frecuentes
              </h2>
            </div>

            <div className="bg-blanco-calido rounded-2xl p-5 md:p-8 shadow-sm border border-beige-claro" data-id="element-161">
              {FAQS.map((faq, i) => <AccordionItem key={i} question={faq.q} answer={faq.a} data-id="element-162" />)}
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-marron-suave text-blanco-calido py-8 px-4 text-center" data-id="element-163">
        <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-164">
          <img src="https://cdn.magicpatterns.com/uploads/5ZigZuXxwGGLDXYnP8vuh8/LOGO_DECOEMPRENDE.png" alt="Deco Emprende" className="h-12 object-contain mb-4 brightness-0 invert opacity-80" data-id="element-165" />
          <p className="text-blanco-calido/60 text-xs" data-id="element-166">
            © {new Date().getFullYear()} Deco Emprende. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 p-3 bg-blanco-calido/95 backdrop-blur-md border-t border-beige-claro shadow-[0_-10px_20px_rgba(0,0,0,0.05)] md:hidden z-50 flex justify-center" data-id="element-167">
        <button onClick={scrollToOffer} className="w-full bg-terracota text-blanco-calido font-bold py-3 px-6 rounded-full shadow-md text-sm" data-id="element-168">
          Acceder con 50% OFF
        </button>
      </div>
    </div>;
}